import React from "react";
import Task_tracker from "./components/Task_tracker";

function App() {
  return (
    <div className='bg-cyan-500 min-h-screen flex justify-center items-center image'>
      <Task_tracker />
    </div>
  );
}

export default App;
